"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable max-classes-per-file no-use-before-declare
var symbol_observable_1 = __importDefault(require("symbol-observable"));
/* istanbul ignore next */
var $$toStringTag = (typeof Symbol === 'function' && Symbol.toStringTag) || '@@toStringTag';
var fromArray = function (arrayLike) {
    return function (observer) {
        for (var index = 0; index < arrayLike.length; index += 1) {
            if (observer.closed) {
                return;
            }
            observer.next(arrayLike[index]);
        }
        observer.complete();
    };
};
var fromIterable = function (iterable) {
    var iterator = iterable[Symbol.iterator]();
    return function (observer) {
        var iteratorNormalCompletion = true;
        var iteratorError;
        var step = iterator.next();
        try {
            while (!step.done) {
                iteratorNormalCompletion = step.done;
                if (observer.closed) {
                    return;
                }
                observer.next(step.value);
                iteratorNormalCompletion = true;
                step = iterator.next();
            }
            observer.complete();
        }
        catch (e) {
            iteratorError = { e: e };
        }
        finally {
            try {
                /* istanbul ignore next */
                if (!iteratorNormalCompletion && iterator.return) {
                    iterator.return();
                }
            }
            finally {
                if (iteratorError) {
                    observer.error(iteratorError.e);
                }
            }
        }
    };
};
function cleanupSubscription(subscription) {
    var disposer = subscription._disposer;
    if (!disposer) {
        return;
    }
    subscription._disposer = undefined;
    if (typeof disposer === 'function') {
        disposer();
    }
    else {
        if (disposer.unsubscribe) {
            disposer.unsubscribe();
        }
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._closed = true;
}
function notifySubscription(subscription, type, value) {
    if (subscription.closed) {
        return;
    }
    var observer = subscription._observer;
    /* istanbul ignore next */
    if (!observer) {
        return;
    }
    switch (type) {
        case 0 /* next */:
            if (observer.next) {
                observer.next(value);
            }
            break;
        case 1 /* error */:
            closeSubscription(subscription);
            if (observer.error) {
                observer.error(value);
            }
            else {
                cleanupSubscription(subscription);
                throw value;
            }
            break;
        case 2 /* complete */:
            closeSubscription(subscription);
            if (observer.complete) {
                observer.complete();
            }
            break;
    }
    if (subscription.closed) {
        cleanupSubscription(subscription);
    }
}
var ObservableSubscription = /** @class */ (function () {
    function ObservableSubscription(observer, source) {
        this._closed = false;
        this._observer = observer;
        if (observer.start) {
            observer.start(this);
        }
        var subscriptionObserver = new ConcreteObserver(this);
        try {
            this._disposer = source(subscriptionObserver);
        }
        catch (error) {
            if (!observer.error) {
                throw error;
            }
            subscriptionObserver.error(error);
        }
    }
    Object.defineProperty(ObservableSubscription.prototype, "closed", {
        get: function () {
            return this._closed;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        closeSubscription(this);
        cleanupSubscription(this);
    };
    return ObservableSubscription;
}());
var ConcreteObserver = /** @class */ (function () {
    function ConcreteObserver(subscription) {
        this._subscription = subscription;
    }
    Object.defineProperty(ConcreteObserver.prototype, "closed", {
        get: function () {
            return this._subscription.closed;
        },
        enumerable: true,
        configurable: true
    });
    ConcreteObserver.prototype.next = function (value) {
        notifySubscription(this._subscription, 0 /* next */, value);
    };
    ConcreteObserver.prototype.error = function (reason) {
        notifySubscription(this._subscription, 1 /* error */, reason);
    };
    ConcreteObserver.prototype.complete = function () {
        notifySubscription(this._subscription, 2 /* complete */, undefined);
    };
    return ConcreteObserver;
}());
var Observable = /** @class */ (function () {
    function Observable(_subscribe) {
        // This check should stay in case if the ES6->ES5 transpiling is enabled.
        /* istanbul ignore next */
        if (!(this instanceof Observable)) {
            throw new TypeError('Observable cannot be called as a function');
        }
        if (typeof _subscribe !== 'function') {
            throw new TypeError('Observable initializer must be a function');
        }
        this._subscribe = _subscribe;
    }
    Observable.of = function () {
        var C = typeof this === 'function' ? this : Observable;
        return new C(fromArray(arguments));
    };
    Observable.from = function (ish) {
        var C = typeof this === 'function' ? this : Observable;
        var error = ish + " is not an object";
        if (ish == null) {
            throw new TypeError(error);
        }
        if (ish[symbol_observable_1.default]) {
            var observable_1 = ish[symbol_observable_1.default]();
            if (Object(observable_1) !== observable_1) {
                throw new TypeError(error);
            }
            if (observable_1 instanceof Observable && observable_1.constructor === C) {
                return observable_1;
            }
            return new C(function (observer) { return observable_1.subscribe(observer); });
        }
        if (typeof Symbol === 'function' && Symbol.iterator && ish[Symbol.iterator]) {
            return new C(fromIterable(ish[Symbol.iterator]()));
        }
        // For old browsers that doesn't support @@iterator
        /* istanbul ignore next */
        if (Array.isArray(ish)) {
            return new C(fromArray(ish));
        }
        throw new TypeError(error);
    };
    Observable.prototype.subscribe = function (next, error, complete) {
        var observer;
        if (typeof next !== 'object' || next === null) {
            observer = {
                next: next,
                error: error,
                complete: complete
            };
        }
        else {
            observer = next;
        }
        return new ObservableSubscription(observer, this._subscribe);
    };
    Observable.prototype.pipe = function () {
        if (!arguments.length) {
            return this;
        }
        // tslint:disable-next-line no-this-assignment
        var result = this;
        for (var i = 0; i < arguments.length; i += 1) {
            result = arguments[i](result);
        }
        return result;
    };
    Observable.prototype[symbol_observable_1.default] = function () {
        return this;
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map